var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.9984C14.2083 15.9984 15.9985 14.2082 15.9985 11.9999C15.9985 9.79162 14.2083 8.00143 12 8.00143C9.79165 8.00143 8.00146 9.79162 8.00146 11.9999C8.00146 14.2082 9.79165 15.9984 12 15.9984Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2668 9.42008C21.7164 6.89501 18.1897 2.65857 12 2.65857C5.81027 2.65857 2.28358 6.89501 0.733158 9.42008C-0.244386 11.0012 -0.244386 12.999 0.733158 14.5802C2.28358 17.1052 5.81027 21.3417 12 21.3417C18.1897 21.3417 21.7164 17.1052 23.2668 14.5802C24.2443 12.999 24.2443 11.0012 23.2668 9.42008ZM12 17.9979C8.68752 17.9979 6.0022 15.3126 6.0022 12.0001C6.0022 8.68764 8.68752 6.00233 12 6.00233C15.3124 6.00233 17.9978 8.68764 17.9978 12.0001C17.9944 15.3112 15.3111 17.9945 12 17.9979Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeWhite);
export default __webpack_public_path__ + "static/media/eyeWhite.40677dfb3f2c176a481c6c3245cdbc55.svg";
export { ForwardRef as ReactComponent };